import zod from 'zod';
import { stringToBoolean, stringToListOfEnum, zodLimit, zodPage } from './helpers';
import { companyTypeWithoutBoth, inscriptionStatus } from '../services/central-api/third-party-approved-companies';

const InscriptionsManagementSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    status: stringToListOfEnum(zod.enum(inscriptionStatus)).optional(),
    companyType: stringToListOfEnum(zod.enum(companyTypeWithoutBoth)).optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional()
});

const InscriptionFormSchema = zod.object({
    id: zod.string().optional(),
}).optional();

const DonatedCamerasListSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    // cameraType: zod.enum(cameraTypes).optional(),
    integrationType: stringToListOfEnum(zod.enum(['type_2', 'type_3'])).optional(),
    origin: zod.string().optional(),
    // imageProvider: zod.string().optional(),
    // cloudProvider: zod.string().optional(),
    showRejected: zod.coerce.boolean().optional(),
    showRemovedByThirdParty: zod.coerce.boolean().optional(),
    beginIn: zod.coerce.number().optional(),
    hasFacial: stringToBoolean.optional(),
    hasLpr: stringToBoolean.optional(),
});

export const ThirdPartyApprovedCompaniesSchemas = {
    InscriptionsManagement: InscriptionsManagementSchema,
    InscriptionForm: InscriptionFormSchema,
    DonatedCamerasList: DonatedCamerasListSchema,
};
